import { getCsrfTokenFromOtpService } from "modules/Services/LoginService";
import React, { useEffect, useState } from "react";
import { useCookies } from "react-cookie";
import { useHistory, useLocation } from "react-router";

const LoginRedirect: React.FC = (props) => {
  const [values, setValues] = useState({ otp: "", csrf: "" });
  // cookies
  const setCookies = useCookies([])[1];

  // history
  const history = useHistory();
  const location = useLocation();

  // get the queryParams string as an object form URL
  const queryParams = new URLSearchParams(location.search);

  const getCSRF = async () => {
    let { otp } = values;
    await getCsrfTokenFromOtpService(otp)
      .then((res: any) => {
        if (res.data.csrf) {
          history.push("/content/explorer");
        }
      })
      .catch((err: any) => {
        console.log("Getting Error in socket for now", err);
        history.push("/content/explorer");
      });
  };

  useEffect(() => {
    if (queryParams.has("otp") && queryParams.has("csrf")) {
      let otp = queryParams.get("otp") || "",
        csrf = queryParams.get("csrf") || "";
      setValues({ ...values, otp: otp, csrf: csrf });
      queryParams.delete("otp");
      queryParams.delete("csrf");
      history.replace({
        search: queryParams.toString(),
      });
    }
  }, []);

  useEffect(() => {
    if (values.otp.length > 0) {
      getCSRF();
    }
  }, [values]);

  return <div>Redirecting...</div>;
};

export default LoginRedirect;
